import { Link, useNavigate } from "react-router-dom";
import "./../../pagescss/Navbar.css";
import BackButton from "./BackButton";
import { useEffect } from 'react';


const Navbar = () => {
    const navigate = useNavigate();
    const phoneFromStorage = localStorage.getItem('userPhone');


    useEffect(() => {
    const phoneFromStorage = localStorage.getItem('userPhone');
   // if (!phoneFromStorage) {
     // navigate('/login');
   // }
  }, []);


  return (
    <>
    
      <nav>
        <ul>

          <li>
            <Link to="/">
              <img src="/logo.png" className="logo" alt="Study Logo" />
            </Link>
          </li>


          <li className="center-links">
            <Link to="/" className="app-name">NEET Prep App</Link>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/profile">Profile</Link>

                    
          </li>

         {phoneFromStorage ? (<></>):(<>
           <li className="left-links">
            <Link to="/signup">SignUp / Login</Link>
          </li>
          </>)}


         
        </ul>
      </nav>
      <BackButton />
     
    </>
  );
};

export default Navbar;